import { stripOidcCallbackParams } from "core/auth/redirectUri";

/**
 * The query string to stamp `membershipId` onto, or `null` when the URL already
 * says what it should.
 *
 * `liveSearch` must come from `window.location`, never from React Router's
 * `useSearchParams`. Two writers bypass React Router: `onSigninCallback` clears
 * the OIDC params with `history.replaceState`, and nuqs syncs the analytics
 * hub's params shallowly (also `replaceState`, no `navigate`). React Router
 * observes neither, so its snapshot is frozen at the last real navigation — the
 * URL as the page was entered. Merging onto that snapshot republishes it, which
 * resurrects the consumed `code`/`state` right after login and reverts
 * `exploreKey` to whatever the user arrived with.
 */
export const buildMembershipSearch = (liveSearch, membershipId) => {
  const live = new URLSearchParams(liveSearch);
  const next = stripOidcCallbackParams(live);
  next.set("membershipId", membershipId);

  // The stale snapshot also means the caller can re-fire against a URL that is
  // already right; writing nothing keeps it from churning history.
  return next.toString() === live.toString() ? null : next;
};
